module.exports = __webpack_public_path__ + "img/students_rating.22218421.svg";